import BrowserTab from 'www/modules/BrowserTab'

new BrowserTab({
  key: 'BrowserTabGlobalObserver',
})
